import styled from "styled-components";

export const Styled = {
  Link: styled.div`
    display: block;
    text-align: center;
    margin-top: 20px;
    a {
      color: #201F38;
      font-weight: 600;
    }
    img {
      margin-left: 5px;
    }
  `,
};
